import React from "react";
import { getNRErrorInfo } from "@swiggy-private/js-utils";
import Blaze from "@swiggy-private/blaze.js";
import { filterHeadersFromSwiggyHeaders } from "@swiggy-private/portal-swiggy-one-subscription-ui/dist/utils";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendApiError = (apiUrl: string, error: any) => {
    Blaze.recordCustomEvent({
        eventType: `portal_swiggy_one_subscription_api_error`,
        apiUrl,
        ...error,
    });
};

export const sendErrorBoundaryEvent = (
    error?: Error,
    errorInfo?: React.ErrorInfo,
    headers?: Record<string, string | undefined> | void,
) => {
    const swgyHeaders = headers ? filterHeadersFromSwiggyHeaders(headers) : {};
    const errorBoundaryEvents = getNRErrorInfo(error, errorInfo);
    Blaze.recordCustomEvent({
        eventType: "webview_error_boundary",
        appName: "portal_swiggy_one_subscription",
        ...errorBoundaryEvents,
        ...swgyHeaders,
    });
};
